'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSchool = exports.getFeiseannaForSchool = exports.getSchoolCompetitors = exports.schoolCompetitorsAreLoading = exports.schoolCompetitorsUrl = undefined;

var _immutable = require('immutable');

var schoolCompetitorsUrl = exports.schoolCompetitorsUrl = function schoolCompetitorsUrl(sid, fid) {
  return IFEIS_API_URI + '/api/schools/' + sid + '/feiseanna/' + fid;
};

var schoolCompetitorsAreLoading = exports.schoolCompetitorsAreLoading = function schoolCompetitorsAreLoading(state, sid) {
  return !state.getIn(['schools', 'students', sid]) || state.getIn(['schools', 'students', sid, 'loading']);
};

var getSchoolCompetitors = exports.getSchoolCompetitors = function getSchoolCompetitors(state, sid) {
  return state.getIn(['schools', 'students', sid]);
};

var getFeiseannaForSchool = exports.getFeiseannaForSchool = function getFeiseannaForSchool(state, sid) {
  return state.getIn(['schools', 'feiseanna', sid]) || (0, _immutable.List)();
};

var getSchool = exports.getSchool = function getSchool(state, sid) {
  return state.getIn(['schools', 'one', sid]) || (0, _immutable.Map)();
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/schools/paths.js
// module id = 69
// module chunks = 0